"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIGHT_GRAY = exports.SEA_BLUE = exports.LIME_GREEN = exports.MAGENTA = exports.PURPLE_DARK = exports.PURPLE_LIGHT = exports.PURPLE = exports.GREEN_DARK = exports.GREEN_LIGHT = exports.GREEN = exports.INDIGO_BLUE = exports.BLUE_DARK = exports.BLUE_LIGHT = exports.BLUE = exports.ORANGE_DARK = exports.ORANGE_LIGHT = exports.ORANGE = exports.HIGHLIGHT_LIGHT_BLUE = exports.HIGHLIGHT_BLUE = exports.HIGHLIGHT_LIGHT_RED = exports.HIGHLIGHT_RED = exports.LIGHT_GREEN = exports.HIGHLIGHT_GREEN = void 0;
exports.HIGHLIGHT_GREEN = '#60cdb2';
exports.LIGHT_GREEN = '#AFF4B5';
exports.HIGHLIGHT_RED = '#F42A68';
exports.HIGHLIGHT_LIGHT_RED = '#f7728c';
exports.HIGHLIGHT_BLUE = '#3886FF';
exports.HIGHLIGHT_LIGHT_BLUE = '#EEF5FF';
exports.ORANGE = '#fbac3b';
exports.ORANGE_LIGHT = '#FFCF8B';
exports.ORANGE_DARK = '#DD9023';
exports.BLUE = '#3886FF';
exports.BLUE_LIGHT = '#8BB9FF';
exports.BLUE_DARK = '#246BD9';
exports.INDIGO_BLUE = '#231c5b';
exports.GREEN = '#60cdb2';
exports.GREEN_LIGHT = '#B3F1E2';
exports.GREEN_DARK = '#44A58D';
exports.PURPLE = '#6352ef';
exports.PURPLE_LIGHT = '#978AFF';
exports.PURPLE_DARK = '#3F2FC0';
exports.MAGENTA = '#FD88F8';
exports.LIME_GREEN = '#CEF16B';
exports.SEA_BLUE = '#53BBD8';
exports.LIGHT_GRAY = '#dadbd9';
